const breakpoint = {
  xsmall: { shortName: 'xs', name: 'xsmall', value: 360, em: 22.5 },
  small: { shortName: 's', name: 'small', value: 425, em: 26.5625 },
  medium: { shortName: 'm', name: 'medium', value: 768, em: 48 },
  large: { shortName: 'l', name: 'large', value: 1024, em: 64 },
  xlarge: { shortName: 'xl', name: 'xlarge', value: 1440, em: 90 },
  fourk: { shortName: '4k', name: '4k', value: 2560, em: 160 },
}
export default breakpoint
